module.exports = __webpack_public_path__ + "img/FLV_video_icon@2x.ba818802.png";